var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "safety-critical",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.982,
    height: 17.611,
    viewBox: "0 0 19.982 17.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1270.6,695.116a.8.8,0,1,0,.8.8.788.788,0,0,0-.232-.566.8.8,0,0,0-.571-.237",
    transform: "translate(-1269.792 -695.116)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 1.608,
    height: 5.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1280.827,698.773l-9.217-16.056a.766.766,0,0,0-.669-.389.781.781,0,0,0-.671.389l-9.217,16.055a.778.778,0,0,0,.668,1.167h18.437a.764.764,0,0,0,.669-.389A.786.786,0,0,0,1280.827,698.773Zm-2.008-.389h-15.76l7.882-13.728Z",
    transform: "translate(-1260.948 -682.328)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(8.844 12.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 11.608,
    height: 11.608,
    transform: "translate(-5 -5)",
    fill: "#e21313"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(8.844 6.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 11.608,
    height: 15.628,
    transform: "translate(-5 -5)",
    fill: "#e21313"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 29.982,
    height: 27.611,
    transform: "translate(-5 -5)",
    fill: "#e21313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyCritical);
export default __webpack_public_path__ + "static/media/safety-critical.cb9fd56c714019c4bf4a4955557ca363.svg";
export { ForwardRef as ReactComponent };